//Types
export var MASTER_DATA_RESET_ACTION_TYPE = "master_data/reset";
export var MASTER_DATA_FETCH_START_ACTION_TYPE = "master_data/fetch_start";
export var MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE = "matser_data/fetch_success";
export var MASTER_DATA_SET_ACTION_TYPE = "master_data/set";
export var MASTER_DATA_ERROR_ACTION_TYPE = "master_data/error";
